import { FunctionComponent, useRef } from "react";
import { useTranslation } from "react-i18next";

import { faFile } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SharePointImage from "../../../../../../assets/icons/icon-sharepoint.png";
import { TooltipWrapper } from "../../../../../components/Shared/Components/TooltipWrapper/TooltipWrapper";
import { translationKeys } from "../../../../../models/app-translation-keys";

interface IKnowledgeBaseTypeIconProps {
  isSpoKnowledgebase: boolean;
  iconStyles?: {
    width?: string;
    height?: string;
    maxWidth?: string;
    maxHeight?: string;
  };
  setIsTooltipVisible?: (visible: boolean) => void;
}

export const KnowledgeBaseTypeIcon: FunctionComponent<IKnowledgeBaseTypeIconProps> = (
  props: IKnowledgeBaseTypeIconProps,
) => {
  const { t } = useTranslation();
  const typeIconRef = useRef<HTMLDivElement>(null);

  const cmsTranslationKeys = translationKeys.adminArea.cms;

  return (
    <div className="knowledge-base-icon" ref={typeIconRef}>
      <TooltipWrapper
        targetRef={typeIconRef}
        content={
          props.isSpoKnowledgebase
            ? t(cmsTranslationKeys.spoKnowledgeBase.title)
            : t(cmsTranslationKeys.knowledgeBase.title)
        }
        position="right"
        onShow={() => props.setIsTooltipVisible?.(true)}
        onHide={() => props.setIsTooltipVisible?.(false)}
      />
      {props.isSpoKnowledgebase ? (
        <img
          src={SharePointImage}
          style={
            props.iconStyles ?? {
              width: "1rem",
              height: "1rem",
            }
          }
          alt={t(cmsTranslationKeys.spoKnowledgeBase.title)}
        />
      ) : (
        <FontAwesomeIcon icon={faFile} style={props.iconStyles ?? { width: "0.9rem", height: "0.9rem" }} />
      )}
    </div>
  );
};
